import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useAuthUser } from "./useAuthUser"
import { isDev } from "@/utils/isDev"

type CompanyType = "Owned" | "Other"

const ownedCompanyId = isDev() ? "1" : "00112ed2-b85a-4a83-a7a3-d654767f2561"

export const useCompanyType = (): CompanyType => {
    const { token } = useAuth()
    const user = useAuthUser(token)
    return user.companyId === ownedCompanyId ? "Owned" : "Other"
}

export const useIsMatsuriCleaner = (): boolean => {
    return useCompanyType() === "Owned"
}
